module.exports = __webpack_public_path__ + "img/ribbon-premium.ddbec9f6.svg";